import PaginationBoxView from './PaginationBoxView';

module.exports = PaginationBoxView;



/** WEBPACK FOOTER **
 ** ./src/components/pagination/index.jsx
 **/